import React = require('react');
import { OptionsDisplay } from '../OptionsDisplay';

interface IOptionsOverview {
  options: any[];
}

export const OptionsOverview = ({ options }: IOptionsOverview) => {

  const optionNames = [
    'Winter Sports',
    'Cruise Cover',
    'Excess Waiver',
    'Gadget Cover',
    'Hazardous Activities',
    'Enhanced Trip Disruption Cover'
  ];

  return (
    <div className={'details-overview'}>
      <div className={'details-overview-header'}>
        <div className={'d-overview-icon'}>
          <img src={require('../../MakeAChange/Images/add-button.svg')} width={'50px'}/>
        </div>
        <div className={'d-overview-text'}>Additional Cover</div>
      </div>

      {optionNames.map((names, index) => {
        return (
          <div className={'details-overview-row'} key={index}>
            <div className={'d-o-attribute'}>
              <div><OptionsDisplay options={options} optionName={names}/></div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
